module.exports = __webpack_public_path__ + "img/workout8.2668a956.jpg";